<template>
  <div class="footer">
    <div class="main">
      <div class="logocontent">
        <div class="footer-logo">
          <img src="../assets/img/yimo-img/logoMain.png" alt="" />
        </div>
      </div>
      <div class="msg">
        <div class="leftmsg">
          <p>深圳高竞文化传媒有限公司</p>
          <p>Shenzhen Gaojing Culture Media Co., Ltd</p>
          <a class="beian" href="https://beian.miit.gov.cn"> <p>粤ICP备2020113609号-5</p></a>
        </div>
        <div class="rightmsg">
          <p>联系邮箱：service@chinaesport.com</p>
          <p>联系电话：(+86)199 2519 5018</p>
          <p>地址：深圳市南山区粤海街道高新区社区高新南六道8号航盛科技大厦5楼</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
@import url('../assets/css/base.less');
.mb16 {
  margin-bottom: 16px;
}

.scrollbottom {
  display: block;
  min-width: 1300px;
  .footer {
    width: 100vw;
    height: 154px;
    padding-left: 202px;
    padding-bottom: 11px;
    background-color: rgba(9, 92, 249, 1);
    // display: flex;
    // align-items: center;
    z-index: 1;
    // justify-content: center;
    // min-width: 1300px;
    .main {
      // width: 1120px;
      height: 100%;
      display: flex;
      // min-width: 1300px;
      flex-direction: column;
      .logocontent {
        height: 73px;
        width: 104px;
        // width: fit-content;
        position: relative;
        margin-bottom: 8px;
        .footer-logo {
          width: 21.86%;
          position: absolute;
          bottom: 0;
          img {
            width: 127px;
            height: 28px;
          }
        }
      }
      .msg {
        //   scale: 0.8;
        height: 29.2%;
        width: 77%;
        display: flex;
        justify-content: space-between;
        align-content: space-between;
        font-size: 8px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 100;
        color: #ffffff;
        line-height: 22px;
        .leftmsg,
        .rightmsg {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }
      .mainLeft {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .content {
          height: 160px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          color: #4430b4;
          .logo {
            height: 64px;
            img {
              height: 100%;
            }
          }
        }
      }

      .mainRight {
        height: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        color: #4430b4;
        .content {
          height: 150px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          p {
            margin-top: 12px;
          }
        }
      }
    }
  }
}
.beian {
  text-decoration: none;
  color: #fff;
  width: 154px !important;
}
.beian:hover {
  color: #fff;
}
</style>
